var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.72695 21.6246C4.07695 21.6246 3.52279 21.3954 3.06445 20.9371C2.60612 20.4788 2.37695 19.9246 2.37695 19.2746V4.72461C2.37695 4.07461 2.60612 3.51628 3.06445 3.04961C3.52279 2.58294 4.07695 2.34961 4.72695 2.34961H11.477V4.72461H4.72695V19.2746H19.277V12.5246H21.652V19.2746C21.652 19.9246 21.4186 20.4788 20.952 20.9371C20.4853 21.3954 19.927 21.6246 19.277 21.6246H4.72695ZM10.127 15.5246L8.50195 13.8746L17.652 4.72461H12.977V2.34961H21.652V11.0246H19.277V6.37461L10.127 15.5246Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.20bf513c067cf7fb6dbc286ec2c0e867.svg";
export { ForwardRef as ReactComponent };